module.exports = __webpack_public_path__ + "img/50_39.db15877a.png";